import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-ov-slider-poster",
  templateUrl: "./ov-slider-poster.component.html",
  styleUrls: ["./ov-slider-poster.component.scss"],
})
export class OvSliderPosterComponent {
  slides = [
    { img: "assets/img/ov/drumnbass_ig_story.webp" },
    { img: "assets/img/ov/hiphop_ig_story.webp" },
    { img: "assets/img/ov/elektro_ig_story.webp" },
    { img: "assets/img/ov/house_ig_story.webp" },
  ];

  breakpoints = [
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ];

  slideConfig = {
    dots: true,
    arrows: true,
    responsive: this.breakpoints,
  };

  breakpoint() {
    console.log("breakpoint");
  }
  constructor() {}
}
